import { useContext, useEffect, useState } from "react";
import CountryConfigContext from "../../../../CountryConfigContext";
import useCountryAxiosInstance from "../../../../hooks/useCountryAxiosInstance";

export const fetchSystemsById = (apiRequest, ids) =>
  apiRequest.get(`/systems/all?ids=${ids.join(",")}`);

export const getConfiguratorSystemsToFetch = (data, config) =>
  data
    .reduce((acc, step) => [...acc, ...step.systems], [])
    .filter((id) => !config.systems[id])
    .filter((id, idx, arr) => arr.indexOf(id) === idx);  // drop duplicates in order to avoid requests with unnecessary long urls

export const reduceSystems = (systems) =>
  systems.reduce((acc, system) => ({ ...acc, [system.id]: system }), {});

const useFetchFixedSystems = (data) => {
  const [fetchFixedSystems, setFetchFixedSystems] = useState(false);
  const { setConfig, config } = useContext(CountryConfigContext);
  const apiRequest = useCountryAxiosInstance();
  useEffect(() => {
    const fetchSystems = async (ids) => {
      try {
        const systems = await fetchSystemsById(apiRequest, ids);
        setConfig({
          ...config,
          systems: {
            ...config.systems,
            ...reduceSystems(systems),
          },
        });
        setFetchFixedSystems(true);
      } catch (error) {
        console.log(error);
        setFetchFixedSystems("error");
      }
    };

    if (data && !fetchFixedSystems) {
      const systemsToFetch = getConfiguratorSystemsToFetch(data, config);

      if (systemsToFetch.length) {
        fetchSystems(systemsToFetch);
      } else {
        setFetchFixedSystems(true);
      }
    }

    // eslint-disable-next-line
  }, [data]);

  return fetchFixedSystems;
};

export default useFetchFixedSystems;
